import React from "react";
import { Box, IconButton, Typography, Grid } from "@mui/material";
import { ReactComponent as VisibilityIcon } from "../assets/icons/visibility.svg";
import defaultProfile from "../assets/images/defaultProfile2.webp";
import { colors } from "../values/colors";
import {
    formatTimestampToReadableDate,
    getAgeFromTimestamp,
    getDobFromTimestamp,
} from "../uttils/common";

const PlayerAuctionCard = ({
    player,
    playerNumber,
    roleName,
    isJitoTournament,
    showVisibilityIcon = false,
    onViewProfile,
}) => {
    const gradientTextStyle = {
        background: colors.primary,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontWeight: "700",
    };

    return (
        <Box
            sx={{
                display: "flex",
                border: "1px solid #E0E0E0",
                borderRadius: "12px",
                overflow: "hidden",
                bgcolor: "white",
                height: "100%",
                minHeight: "450px",
                maxHeight: "800px",
            }}
        >
            <Box
                sx={{
                    width: "50%",
                    position: "relative",
                    borderRight: "1px solid #E0E0E0",
                }}
            >
                <img
                    src={player?.playerId?.profilePic || defaultProfile}
                    alt="profile"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
                {showVisibilityIcon && (
                    <IconButton
                        onClick={onViewProfile}
                        sx={{
                            position: "absolute",
                            top: 15,
                            right: 15,
                            bgcolor: "#1A1B23",
                            color: "white",
                            "&:hover": { bgcolor: "#000" },
                        }}
                    >
                        <VisibilityIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>

            <Box
                sx={{
                    p: 2,
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                }}
            >
                <Typography sx={{ fontSize: "1.6rem", fontWeight: "600", mb: 0.5 }}>
                    Player ID:{" "}
                    <span style={{ ...gradientTextStyle }}>{playerNumber || "-"}</span>
                </Typography>
                <Typography sx={{ fontSize: "1.6rem", fontWeight: "600", mb: 0.5 }}>
                    Name:{" "}
                    <span style={{ ...gradientTextStyle }}>
                        {player?.playerId?.name || "Paul C. Ramos"}
                    </span>
                </Typography>

                <Grid container spacing={2}>
                    {[
                        { label: "Role", value: roleName },
                        { label: "T-Shirt Size", value: player?.shirtSize },
                        {
                            label: "Age",
                            value: (player?.dob || player?.playerId?.dob)
                                ? getAgeFromTimestamp(player?.dob || player?.playerId?.dob)
                                : undefined,
                        },
                        {
                            label: "DOB",
                            value: (player?.dob || player?.playerId?.dob)
                                ? getDobFromTimestamp(player?.dob || player?.playerId?.dob)
                                : undefined,
                        },
                        { label: "Batting Style", value: player?.battingStyle },
                        { label: "Bowling Style", value: player?.bowlingStyle },
                        { label: "City", value: player?.city },

                        // Only push this object if tournament is JITO
                        ...(isJitoTournament
                            ? [
                                {
                                    label: "Jito Member",
                                    value: player?.isJitoMember ? "Yes" : "No",
                                },
                            ]
                            : []),
                    ]
                        .filter(
                            (item) =>
                                item.value !== null && item.value !== undefined && item.value !== ""
                        )
                        .map((item, idx) => (
                            <Grid item xs={6} key={idx}>
                                <Typography sx={{ fontSize: "1.6rem", fontWeight: "600" }}>
                                    {item.label}:{" "}
                                    <span style={{ ...gradientTextStyle, fontWeight: "700" }}>
                                        {item.value}
                                    </span>
                                </Typography>
                            </Grid>
                        ))}
                </Grid>

                {isJitoTournament && player?.jitoMemberType && (
                    <Typography
                        sx={{ fontSize: "1.6rem", fontWeight: "600", pt: 1, mb: 0.5 }}
                    >
                        Jito Member Type:{" "}
                        <span style={{ ...gradientTextStyle, fontWeight: "700" }}>
                            {player?.jitoMemberType}
                        </span>
                    </Typography>
                )}

                <Box sx={{ mt: 1 }}>
                    <Typography sx={{ fontWeight: "600", fontSize: "1.6rem" }}>
                        Availability:
                    </Typography>
                    <Typography
                        sx={{
                            ...gradientTextStyle,
                            fontSize: "1.6rem",
                            fontWeight: "700",
                            mt: 0.5,
                        }}
                    >
                        {player?.playerAvailable?.length > 0
                            ? player.playerAvailable
                                .map((ts) => formatTimestampToReadableDate(ts))
                                .join(", ")
                            : "Not Available on any dates"}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default PlayerAuctionCard;
